<div
    *ngIf="nextTariff !== ETariffAbbr.FREE && !isEduSite"
    class="alert alert-paid has-paid-badge"
    [class]="getTariffCssClass"
>
    <span class="badge badge-paid" [class]="getTariffCssClass">&nbsp;</span>

    {{ "widget_tariff_restriction_less_pro_text" | translate }}&#46;

    <a href="/landing-pages/plans/" target="_blank">
        {{ "change_tariff_link" | translate }} <small class="sp-icon icon-outgoing small-xs"></small>
    </a>
</div>
